import {
  AdditionalApiRequest,
  UpdateAdditionalRequest,
  DeleteAdditionalRequest,
} from '@/data/payload/api/AdditionalInfoRequest'
import {
  PostAdditionalInterface,
  DeleteAdditionalInterface,
  UpdateAdditionalInterface,
} from '@/data/payload/contracts/AdditionalInfoRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { AdditionalInfoDataMapper } from '@/data/persistences/mappers/AdditionalInfoDataMapper'
import { AdditionalInfoRepositoryInterface } from '@/data/persistences/repositories/contracts/AdditionalInfoRepositoryInterface'
import { AdditionalInfo } from '@/domain/entities/AdditionalInfo'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class AdditionalInfoApiRepository
  implements AdditionalInfoRepositoryInterface {
  private service: ApiService
  private mapper: AdditionalInfoDataMapper

  constructor(service: ApiService, mapper: AdditionalInfoDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(params: Object): Promise<AdditionalInfo> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.MATERIAL_ADDITIONAL,
      params
    )
    return this.mapper.convertAdditionalInfoFromApi(resp)
  }

  public async post(payload: PostAdditionalInterface): Promise<AdditionalInfo> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.MATERIAL_ADDITIONAL,
      undefined,
      payload as AdditionalApiRequest,
      undefined,
      'form-data'
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async update(
    payload: UpdateAdditionalInterface,
    id: number
  ): Promise<AdditionalInfo> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.MATERIAL_ADDITIONAL}/${id}`,
      undefined,
      payload as UpdateAdditionalRequest,
      undefined,
      'form-data'
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async delete(
    payload: DeleteAdditionalInterface
  ): Promise<AdditionalInfo> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.MATERIAL_ADDITIONAL_DELETE,
      undefined,
      payload as DeleteAdditionalRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }
}
